const mounted = new WeakSet<Element>();

export const isMounted = (host: Element): boolean => mounted.has(host);

export const markMounted = (host: Element): void => {
  mounted.add(host);
};

export const unmark = (host: Element): void => {
  mounted.delete(host);
};
